import React, { Component } from 'react';
import './DocsToc.css';

class PoliciesTocMain extends Component {

  render() {
    return (
      <nav className="docs-nav">
        <ul>
          <li id="privacy" className={this.props.policyInFocus === "privacy" ? "active" : ""}>
            <a className="docs-nav-item" href='#!' onClick={(e) => {this.props.setPolicyInFocus("privacy", e)}} >Privacy Policy</a>
          </li>
          <li id="terms" className={this.props.policyInFocus === "terms" ? "active" : ""}>
            <a className="docs-nav-item" href='#!' onClick={(e) => {this.props.setPolicyInFocus("terms", e)}} >Terms and Conditions</a>
          </li>
        </ul>
      </nav>
    );
  }
}

export default PoliciesTocMain;